import React, { useCallback, useEffect, useState } from "react";
import styles from "../tablesStyle/ArrivalSection.module.css";
import CustomSelect from "../../customComponents/CustomSelect";
import WarehouseModal from "./customComponentsTable/WarehouseModal";
import SidePanel from "./customComponentsTable/SidePanel";
import { API_URL } from "../../config/api";

const ArrivalSection = () => {
  const token = localStorage.getItem("token");

  const [warehouse, setWarehouse] = useState(1);
  const [Employees, setEmployees] = useState("");
  const [ProductSearch, setProductSearch] = useState("");
  const [Payment, setPayment] = useState("");
  const [Categories, setCategories] = useState("");
  const [type, setType] = useState("");
  const [Status, setStatus] = useState("");
  const [client, setClient] = useState("");
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalDebt, setTotalDebt] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [storages, setStorages] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  useEffect(() => {
    const fetchStorages = async () => {
      try {
        console.log("📡 Загружаем склады...");
        const res = await fetch(`${API_URL}/api/storages?status=active`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        console.log("GET storages response:", data);

        if (Array.isArray(data.data)) {
          setStorages(data.data);
          localStorage.setItem("storages", JSON.stringify(data.data));
        } else {
          console.warn("⚠️ Ожидался массив складов, но пришло:", data);
        }
      } catch (err) {
        console.error("Ошибка при загрузке складов:", err);
        const saved = localStorage.getItem("storages");
        if (saved) setStorages(JSON.parse(saved));
      }
    };

    if (token) fetchStorages();
    else console.error("❌ Нет токена! Авторизация не выполнена.");
  }, [token]);

  // ✅ ESLint fix: useCallback для стабильной ссылки + корректные deps
  const fetchStockChanges = useCallback(
    async (storageId) => {
      try {
        console.log(`📡 Загружаем изменения для склада #${storageId}...`);
        const res = await fetch(
          `${API_URL}/api/stock_changes?storage_id=${storageId}&type=receival`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        console.log("GET stock_changes response:", data);

        const stockData = Array.isArray(data.data) ? data.data : [];
        let expenseSum = 0;
        let profitSum = 0;
        let paidSum = 0;

        const mappedData = stockData.map((item) => {
          const income = parseFloat(item.p_income || 0);
          const profit = parseFloat(item.p_profit || 0);
          const paid = parseFloat(item.paid_amount || 0);

          expenseSum += income;
          profitSum += profit;
          paidSum += paid;

          const warehouseObj = storages.find((s) => s.id === item.storage_id);
          const warehouseName = warehouseObj ? warehouseObj.name : `Склад #${item.storage_id}`;

          return {
            id: item.id,
            invoice: item.name,
            date: new Date(item.inserted_at).toLocaleDateString(),
            warehouse: warehouseName,
            warehouse_id: item.storage_id,
            warehouseName: warehouseName,
            supplier: item.contractor_id ? `Поставщик #${item.contractor_id}` : "—",
            employee: "—",
            amount: income.toFixed(2) + " ₸",
            paymentStatus: item.status === "complete" ? "Завершено" : "Незавершено",
            paymentMethod: "—",
          };
        });

        setTableData(mappedData);
        setTotalExpense(expenseSum);
        setTotalProfit(profitSum);
        setTotalDebt(expenseSum - paidSum);

        localStorage.setItem(`stock_changes_${storageId}`, JSON.stringify(mappedData));
      } catch (err) {
        console.error("Ошибка при загрузке stock_changes:", err);
        const saved = localStorage.getItem(`stock_changes_${storageId}`);
        if (saved) setTableData(JSON.parse(saved));
      }
    },
    [token, storages]
  );

  // ✅ ESLint fix: добавили fetchStockChanges в deps
  useEffect(() => {
    if (storages.length > 0 && warehouse) {
      fetchStockChanges(warehouse);
    }
  }, [warehouse, storages, fetchStockChanges]);

  return (
    <div className={styles.container}>
      <button className={styles.addCustomers} onClick={() => setShowWarehouseModal(true)}>
        +
      </button>

      <WarehouseModal
        isOpen={showWarehouseModal}
        onClose={() => setShowWarehouseModal(false)}
        onSelect={(warehouse) => {
          console.log("Склад получен в ArrivalSection:", warehouse);
          setSelectedWarehouse({ warehouse });
          setShowWarehouseModal(false);
          setShowSidePanel(true);
        }}
      />

      <div className={styles.blockMoney}>
        <div className={styles.blockMoneyOne}>
          <h3 className={styles.blockMoneyHead}>Расход</h3>
          <p className={styles.blockMoneySum}>{totalExpense.toFixed(2)} ₸</p>
        </div>
        <div className={styles.blockMoneyTwo}>
          <h3 className={styles.blockMoneyHead}>Итого задолженность</h3>
          <p className={styles.blockMoneySum}>{totalDebt.toFixed(2)} ₸</p>
        </div>
        <div className={styles.blockMoneyThree}>
          <h3 className={styles.blockMoneyHead}>Возможная прибыль</h3>
          <p className={styles.blockMoneySum}>{totalProfit.toFixed(2)} ₸</p>
        </div>
      </div>

      <div className={styles.filter}>
        <CustomSelect
          className={styles.filters__select}
          options={["Тип 1", "Тип 2", "Тип 3", "Тип 4"]}
          value={type}
          onChange={setType}
          placeholder="Тип"
        />
        <CustomSelect
          className={styles.filters__select}
          options={storages.map((s) => ({ label: s.name, value: s.id }))}
          value={warehouse}
          onChange={setWarehouse}
          placeholder="Склад"
        />
        <input type="date" name="date" className={styles.date} />
        <CustomSelect
          className={styles.filters__select}
          options={["Имя 1", "Имя 2", "Имя 3", "Имя 4"]}
          value={Employees}
          onChange={setEmployees}
          placeholder="Сотрудник"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Товар 1", "Товар 2"]}
          value={ProductSearch}
          onChange={setProductSearch}
          placeholder="Поиск товара"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Поставщик 1", "Поставщик 2"]}
          value={Payment}
          onChange={setPayment}
          placeholder="Поиск поставщика"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Оплата 1", "Оплата 2"]}
          value={Categories}
          onChange={setCategories}
          placeholder="Способ оплаты"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Категории 1", "Категории 2"]}
          value={Status}
          onChange={setStatus}
          placeholder="Поиск категории"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Статус 1", "Статус 2", "Статус 3"]}
          value={client}
          onChange={setClient}
          placeholder="Статус оплаты"
        />
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Накладная</th>
              <th>Дата</th>
              <th>Склад</th>
              <th>Поставщик</th>
              <th>Сотрудник</th>
              <th>Сумма</th>
              <th>Оплата</th>
              <th>Способ оплаты</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length === 0 ? (
              <tr>
                <td colSpan={8}>Нет данных</td>
              </tr>
            ) : (
              tableData.map((row, index) => (
                <tr
                  key={index}
                  onClick={() => {
                    setSelectedWarehouse({
                      warehouse: {
                        id: row.warehouse_id,
                        name: row.warehouseName,
                      },
                      invoiceId: row.id,
                    });
                    setShowSidePanel(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    {row.invoice} {row.id}
                  </td>
                  <td>{row.date}</td>
                  <td>{row.warehouse}</td>
                  <td>{row.supplier}</td>
                  <td>{row.employee}</td>
                  <td>{row.amount}</td>
                  <td>{row.paymentStatus}</td>
                  <td>{row.paymentMethod}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showSidePanel && (
        <SidePanel
          warehouse={selectedWarehouse?.warehouse}
          invoiceId={selectedWarehouse?.invoiceId}
          onClose={() => {
            setShowSidePanel(false);
            setSelectedWarehouse(null);
          }}
          onComplete={() => fetchStockChanges(warehouse)}
        />
      )}
    </div>
  );
};

export default ArrivalSection;
